import { render, staticRenderFns } from "./explainer_search.vue?vue&type=template&id=463a9556"
import script from "./explainer_search.vue?vue&type=script&lang=js"
export * from "./explainer_search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports